// 需要浏览器环境登录认证的路由路径配置
export const authRequiredRoutes = [
  "/mx-shop-micro/product", // 商品详情页
  // 在这里添加其他需要认证的路由路径
];

/**
 * 检查路径是否需要认证
 * @param pathname 当前路径
 * @returns 是否需要认证
 */
export const isAuthRequired = (pathname: string): boolean => {
  return authRequiredRoutes.includes(pathname);
};
